import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { BASE_URL } from "@/shared/config/constants"
import { WebApp } from "@/shared/telegram"

import { GRID_WRITE_SCOPE, SETTINGS_WRITE_SCOPE_HEADER, isGridWriteScopeActive } from "./write-scope/write-scope-slice"

export type TagTypes =
  | "Balance"
  | "UserSettings"
  | "GroupSettings"
  | "Prompt"
  | "PromptsList"
  | "TopicPrompt"
  | "TopicPromptsList"
  | "Document"
  | "DocumentsList"
  | "DocumentPlace"
  | "DocumentPlacesList"
  | "RankUpdate"
  | "PermissionUpdate"
  | "Greeting"
  | "GreetingUpdate"
  | "Farewell"
  | "FarewellUpdate"
  | "LeavePunishment"
  | "Rules"
  | "RulesUpdate"
  | "AutoMessage"
  | "AutoMessageUpdate"
  | "QuietMode"
  | "SecurityRule"
  | "SecurityRules"
  | "SafeList"
  | "WarningRule"
  | "Commands"
  | "Topics"
  | "Reports"
  | "FeaturesStatus"
  | "Subscription"
  | "PersonalSubscription"
  | "BusinessConnection"
  | "BusinessSubscription"
  | "BusinessPrompt"
  | "BusinessDocument"
  | "BusinessDocumentsList"
  | "BusinessUsageStats"
  | "BusinessTriggers"
  | "Clone"
  | "CloneList"
  | "ChatGrids"
  | "ChatGridAdmins"
  | "Leaderboard"

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      if (WebApp.initData) {
        headers.set("X-Telegram-Init-Data", WebApp.initData)
        headers.set("Authorization", `Bearer ${WebApp.initData}`)
      }
      if (isGridWriteScopeActive(getState())) {
        headers.set(SETTINGS_WRITE_SCOPE_HEADER, GRID_WRITE_SCOPE)
      }
      return headers
    }
  }),
  tagTypes: [
    "Balance",
    "UserSettings",
    "GroupSettings",
    "Prompt",
    "PromptsList",
    "TopicPrompt",
    "TopicPromptsList",
    "Document",
    "DocumentsList",
    "DocumentPlace",
    "DocumentPlacesList",
    "RankUpdate",
    "PermissionUpdate",
    "Greeting",
    "GreetingUpdate",
    "Farewell",
    "FarewellUpdate",
    "LeavePunishment",
    "Rules",
    "RulesUpdate",
    "AutoMessage",
    "AutoMessageUpdate",
    "QuietMode",
    "SecurityRule",
    "SecurityRules",
    "SafeList",
    "WarningRule",
    "Commands",
    "Topics",
    "Reports",
    "FeaturesStatus",
    "Subscription",
    "PersonalSubscription",
    "BusinessConnection",
    "BusinessSubscription",
    "BusinessPrompt",
    "BusinessDocument",
    "BusinessDocumentsList",
    "BusinessUsageStats",
    "BusinessTriggers",
    "Clone",
    "CloneList",
    "ChatGrids",
    "ChatGridAdmins",
    "Leaderboard",
    "SupportModeValidation",
    "AdminGroups",
    "CloneChats"
  ],
  endpoints: () => ({})
})
